import { TOURIST_SOURCE_MAP_VISUALIZERS_SET_SHOWN_STATE, TOURIST_SOURCE_SET_CURRENT_SELECTION } from './actionTypes'

export function touristSourceMapVisualizerSetShownState(mapVisualizerIndex, shownRegion, shownDataType, shownSource) { return { type: TOURIST_SOURCE_MAP_VISUALIZERS_SET_SHOWN_STATE, mapVisualizerIndex, shownRegion, shownDataType, shownSource }}
export function touristSourceSetCurrentSelection(region, dataType, source) { return { type: TOURIST_SOURCE_SET_CURRENT_SELECTION, region, dataType, source}}


// WEBPACK FOOTER //
// ./src/actions/touristSourceState.js